interface AppleIconProps {
  className?: string
  width?: number
  height?: number
  fill?: string
}

export default function AppleIcon(props: AppleIconProps) {
  const { className, width = 20, height = 20, fill = "currentColor" } = props

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 384 512"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 142 4 219.8 4 305.5 4 356 22.2 409.2 44.8 445.4c21.5 34.3 47.1 72.8 80.7 71.4 32.2-1.3 44.4-20.7 83.3-20.7 37.8 0 48.6 20.7 82.5 20.7 35 0 57.1-31.5 77.6-65.9 24.9-39 35.2-76.8 35.8-78.8-2.1-.7-85.6-32.8-86-103.4zM260.2 105.4c16.9-20 28.4-47.9 25.2-75.5-24.3 1-53.8 17.1-70.9 37.1-15.3 17.7-28.7 45.8-25 72.9 27.1 2.1 53.8-13.6 70.7-34.5z" />
    </svg>
  )
}
